import { IssueAvailableProduct, IssueAvailableProducts } from '@pressreader/content-types';

import { AvailableProductsDto } from '../types';

enum ProductType {
    SingleIssue = 2,
    SingleTitle = 3,
}

const extractProductsByType = (response: AvailableProductsDto, type: number): IssueAvailableProduct[] =>
    response
        .filter(product => product.Type === type)
        .reduce<Array<IssueAvailableProduct>>((acc, product) => {
            Object.entries(product.Pricing).forEach(([currency, { Total }]) => {
                acc.push({
                    price: Total,
                    currency,
                });
            });
            return acc;
        }, []);

const mapAvailableProductsDto = (response: AvailableProductsDto): IssueAvailableProducts => ({
    singleIssueProducts: extractProductsByType(response, ProductType.SingleIssue),
    singleTitleProducts: extractProductsByType(response, ProductType.SingleTitle),
});

export { mapAvailableProductsDto };
